import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreHref?: string;
  moreLabel?: string;
  action?: ReactNode;
  level?: "h2" | "h3";
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreHref,
  moreLabel = "查看更多",
  action,
  level = "h2",
}: SectionHeadingProps) {
  const Heading = level;
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <Heading className="font-heading text-lg font-black text-foreground-950 md:text-xl">
            {title}
          </Heading>
          {subtitle && (
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
      {moreHref && !action && (
        <Link
          to={moreHref}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}